import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

type TableSkeletonLoaderProps = {
  numRows?: number;
  height?: number;
};

const TableSkeletonLoader = ({
  numRows = 10,
  height = 48,
}: TableSkeletonLoaderProps) => {
  return (
    <Stack spacing={1.5} sx={{ pt: 2, width: '100%' }}>
      {Array.from({ length: numRows }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          height={height}
          animation="wave"
          sx={{
            borderRadius: '10px',
            bgcolor: index % 2 === 0 ? 'rgba(0, 0, 0, 0.04)' : 'rgba(0, 0, 0, 0.02)',
          }}
        />
      ))}
    </Stack>
  );
};

export default TableSkeletonLoader;

